__turbopack_context__.v({
  "className": "montserrat_a6b8e55e-module__JnHUVq__className",
  "variable": "montserrat_a6b8e55e-module__JnHUVq__variable",
});
